import { LANGUAGES } from '@/utils/constants'

const { PORTUGUESE, ENGLISH, SPANISH } = LANGUAGES

export const USERNAME = 'username'
export const NONE = 'none'
export const METHOD = 'method'
export const GET = 'get'
export const POST = 'post'
export const PUT = 'put'
export const DELETE = 'delete'
export const SUCCESS = 'success'
export const CLIENT_ERROR = 'client error'
export const SERVER_ERROR = 'client error'
export const UNKNOWN = 'Unknown'
export const ROUTE = 'route'
export const SORT_BY = 'sort by'
export const NEWEST = 'newest'
export const OLDEST = 'oldest'
export const SEARCH = 'search'
export const STATUS = 'status'
export const TIME = 'time'
export const PARAMS = 'params'

export default {
  [PORTUGUESE]: {
    [USERNAME]: 'Nome do usuário',
    [NONE]: 'Nenhum',
    [METHOD]: 'Método',
    [GET]: 'Pegar',
    [POST]: 'Publicar',
    [PUT]: 'Por',
    [DELETE]: 'Deletar',
    [SUCCESS]: 'Sucesso',
    [CLIENT_ERROR]: 'Erro do Cliente',
    [SERVER_ERROR]: 'Erro de Servidor',
    [UNKNOWN]: 'Desconhecido',
    [ROUTE]: 'Rota',
    [SORT_BY]: 'Ordenar por',
    [NEWEST]: 'Mais novo',
    [OLDEST]: 'Mais antigo',
    [SEARCH]: 'Pesquisar',
    [STATUS]: 'Status',
    [TIME]: 'Tempo',
    [PARAMS]: 'Parâmetros',
  },

  [ENGLISH]: {
    [USERNAME]: 'Username',
    [NONE]: 'None',
    [METHOD]: 'Method',
    [GET]: 'Get',
    [POST]: 'Post',
    [PUT]: 'Put',
    [DELETE]: 'Delete',
    [SUCCESS]: 'Success',
    [CLIENT_ERROR]: 'Client Error',
    [SERVER_ERROR]: 'Server Error',
    [UNKNOWN]: 'Unknown',
    [ROUTE]: 'Route',
    [SORT_BY]: 'Sort By',
    [NEWEST]: 'Newest',
    [OLDEST]: 'Oldest',
    [SEARCH]: 'Search',
    [STATUS]: 'Status',
    [TIME]: 'Time',
    [PARAMS]: 'Params',
  },

  [SPANISH]: {
    [USERNAME]: 'Nombre de usuario',
    [NONE]: 'Ninguno',
    [METHOD]: 'Método',
    [GET]: 'Obtener',
    [POST]: 'Correo',
    [PUT]: 'Poner',
    [DELETE]: 'Borrar',
    [SUCCESS]: 'Éxito',
    [CLIENT_ERROR]: 'Error del Cliente',
    [SERVER_ERROR]: 'Erro do Cliente',
    [UNKNOWN]: 'Desconocido',
    [ROUTE]: 'Ruta',
    [SORT_BY]: 'Ordenar por',
    [NEWEST]: 'El mas nuevo',
    [OLDEST]: 'El mas viejo',
    [SEARCH]: 'Búsqueda',
    [STATUS]: 'Estado',
    [TIME]: 'Hora',
    [PARAMS]: 'Parámetros',
  },
}
